import { render, staticRenderFns } from "./ErrorMessageCollectionModal.vue?vue&type=template&id=15818886&scoped=true&"
import script from "./ErrorMessageCollectionModal.vue?vue&type=script&lang=js&"
export * from "./ErrorMessageCollectionModal.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMessageCollectionModal.vue?vue&type=style&index=0&id=15818886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15818886",
  null
  
)

export default component.exports